import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import cn from "../../utils/cn";

/**
 * InlineNote — a small, reusable informational note (icon + text). Use it to
 * explain caveats or context inline above tables, cards, sections, etc.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children  Note content.
 * @param {"info"|"warning"} [props.type]   Visual tone (default "info").
 * @param {React.ReactNode} [props.icon]    Custom leading icon (defaults per type).
 * @param {string} [props.className]        Extra classes on the container.
 */
const TONES = {
  // Neutral, low-key — reads as a helpful hint, not a warning/error.
  info: "text-black-45",
  warning: "text-[#D48806]",
};

const InlineNote = ({ children, type = "info", icon, className = "" }) => (
  <div
    className={cn("flex items-start gap-1.5 text-xs italic", TONES[type] || TONES.info, className)}
  >
    <span className="mt-[1px] shrink-0 not-italic">{icon ?? <InfoCircleOutlined />}</span>
    <span className="leading-snug">{children}</span>
  </div>
);

export default InlineNote;
